import { env, subEnv } from '../helper/env';

let apiEnv = subEnv;
if (env !== 'prod') {
  apiEnv += '-';
} else {
  apiEnv = '';
}
// 常量配置项等等
// noinspection SpellCheckingInspection
export default {
  appid: 'wx067a0a582dfe4b01',
  platformId: '1194494896220667904', // 平台id
  appName: '蜜柚集市',
  // 测试配置
  // 公众号appid
  memberCardId: 'pdNFU5sqd9IJ0qGvL-eg_Rqja2Gc',
  blackCardDomain: `https://${apiEnv}m.black-unique.com`,
  blackCardH5Domain: `https://${apiEnv}m.black-unique.com`,
  domain: `https://${apiEnv}pyp-api.chuxingyouhui.com`,
  fanxianDomain: `https://${apiEnv}fanxian-api.chuxingyouhui.com`,
  lbsDomain: 'https://lbs.chuxingyouhui.com/api',
  customerDomain: 'https://customer-api.chuxingyouhui.com',
  facadeDomain: `https://${apiEnv}facade-api.black-unique.com`,
  userApiDomain: `https://${apiEnv}user-api.black-unique.com`,
  wechatApiDomain: `https://${apiEnv}wechat-api.black-unique.com`,
  privilegeApiDomain: `https://${apiEnv}privilege-api.black-unique.com`,
  adDomain: `https://${apiEnv}advertise-api.black-unique.com`,
  vipMemberDomain: `https://${apiEnv}vip-member.chuxingyouhui.com`,
  shopDomain: `https://${apiEnv}shop-api.haoyintechnology.com`,
  promoDomain: `https://${apiEnv}market.chuxingyouhui.com`,
  channelId: '10792',
  blindBoxDomain: `https://${apiEnv}api.miyoujs.com`,
  owaimai: `https://${apiEnv}user-api.owaimai.com`,

  // channelId: '10792',
  // 分享默认标题
  // shareTitle: '复制商品链接 查优惠领券拿返现 更省钱',
  // 订阅消息模板id
  // subscribeTemplateId: [
  //   'szWrBlX6T9aY0iW1PKEdKusCueFCSlndaffCM7lJKsU',
  //   'zJ7JCLMSsZ73YCMGWLzhYrePYVbJml1SDMba97ExsWU',
  //   'Xw2Kt4IG921lwOqape_u-qyTllwZTIcL7yaiU0mVOxg',
  // ],
  // takeawaySubscribeTemplateIds: [
  //   '3d1xMbWFmQAotzrR89mygqNqyKsDl5DhQRIIcvUlZs0',
  //   'XA5PCgwRgih-U4YLgkg9_iVtnRvJm5chtDy5xCgRXLQ',
  //   'szWrBlX6T9aY0iW1PKEdKusCueFCSlndaffCM7lJKsU',
  // ],
  // 获取支付参数传递给接口
  payApp: 'weixinMini',
  version: '1.0.14',
  // packageId: '1399666911066882355', // 商家券礼包id，用于正常模式下，获取商家券配置
};
